module.exports = __webpack_public_path__ + "static/media/029.8bcb85c3.jpg";